import { Input, Component, OnInit, OnDestroy } from "@angular/core"
import { Store } from "@ngrx/store"
import { AppState } from "@store/app-state"
import { Enquiry } from "@models/enquiry";

@Component({
  selector: 'online-enrolment-timeline',
  templateUrl: './online-enrolment-timeline.pug',
})
export class OnlineEnrolmentTimelineComponent implements OnInit, OnDestroy {

  @Input() public enquiry: Enquiry

  constructor(
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
  }

  getBarCompleteStyle() {
    let result = {}

    switch (this.enquiry.step) {
      case 1: {
        result = { 'width': '10px' }
        break
      }
      case 2: {
        result = { 'width': '50%' }
        break
      }
      case 3: {
        result = { 'width': '100%' }
        break
      }
    }

    return result
  }

  ngOnDestroy() {
  }

}




// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/online-enrolment-timeline.ts